import { sidebarNavItems, ROUTES } from "../constant";

/**
 * Returns sidebar/mobile-nav section config for school admin role.
 * @param {object} permissionPolicy - role_permission.permission_policy from user data
 */
export const getAdminTabsInfo = (permissionPolicy) => [
  {
    label: "General",
    items: [
      {
        label: sidebarNavItems.adminDashboard,
        route: ROUTES.ADMIN_DASHBOARD,
        icon: "bi-speedometer2",
        canView: true,
      },
    ],
  },
  {
    label: "Academics",
    canView:
      permissionPolicy?.admin_student?.can_view ||
      permissionPolicy?.admin_attendance?.can_view ||
      permissionPolicy?.admin_curriculum?.can_view ||
      permissionPolicy?.admin_teachers?.can_view,
    items: [
      {
        label: sidebarNavItems.adminStudents,
        route: ROUTES.ADMIN_STUDENTS,
        icon: "bi-mortarboard-fill",
        canView: permissionPolicy?.admin_student?.can_view,
      },
      {
        label: sidebarNavItems.adminAttendace,
        route: ROUTES.ADMIN_ATTENDANCE,
        icon: "bi-clipboard-check-fill",
        canView: permissionPolicy?.admin_attendance?.can_view,
      },
      {
        label: sidebarNavItems.adminCurriculum,
        route: ROUTES.ADMIN_CURRICULUM_LIST,
        icon: "bi-file-text-fill",
        canView: permissionPolicy?.admin_curriculum?.can_view,
      },
      {
        label: sidebarNavItems.adminTeachers,
        route: ROUTES.ADMIN_TEACHERS,
        icon: "bi-people-fill",
        canView: permissionPolicy?.admin_teachers?.can_view,
      },
    ],
  },
  {
    label: "Account",
    items: [
      {
        label: sidebarNavItems.adminProfile,
        route: ROUTES.ADMIN_PROFILE,
        icon: "bi-person-circle",
        canView: true,
      },
    ],
  },
];

/**
 * Returns sidebar/mobile-nav section config for student role.
 * @param {string} roleType - role_permission.role_type from user data
 */
export const getStudentTabsInfo = (roleType) => [
  {
    label: "General",
    items: [
      {
        label: sidebarNavItems.dashboard,
        route: ROUTES.DASHBOARD,
        icon: "bi-speedometer2",
      },
      {
        label: sidebarNavItems.booksHomePage,
        route: ROUTES.BOOKS_SELLING_HOME_PAGE,
        icon: "bi-stack",
      },
    ],
  },
  ...(roleType?.indexOf("STUDENT") > -1
    ? [
        {
          label: "Academics",
          items: [
            {
              label: sidebarNavItems.academicCourses,
              route: ROUTES.ACADEMIC_COURSES,
              icon: "bi-mortarboard-fill",
            },
            {
              label: sidebarNavItems.studentNotes,
              route: ROUTES.STUDENT_NOTES,
              icon: "bi-sticky-fill",
            },
          ],
        },
      ]
    : []),
  {
    label: "My Books",
    items: [
      {
        label: sidebarNavItems.bookDashboard,
        route: ROUTES.BOOKS_SELLING_BOOK_DASHBOARD,
        icon: "bi-hdd-stack-fill",
      },
    ],
  },
  {
    label: "Account",
    items: [
      {
        label: sidebarNavItems.profile,
        route: ROUTES.PROFILE,
        icon: "bi-person-circle",
      },
    ],
  },
];

/**
 * Returns the correct tabs config based on role type.
 * @param {string} roleType - role_permission.role_type from user data
 * @param {object} permissionPolicy - role_permission.permission_policy from user data
 */
export const getTabsInfo = (roleType, permissionPolicy) =>
  roleType?.indexOf("SCHOOL") > -1
    ? getAdminTabsInfo(permissionPolicy)
    : getStudentTabsInfo(roleType);
